import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-report',
  templateUrl: './no-report.component.html',
  styleUrls: ['./no-report.component.scss']
})
export class NoReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/report/report component/no-report/no-report.component.ts